// 6-city world clock for the nav footer. 12-hour format, off-hours dimmed.
// Tick fires on the next minute boundary so the display updates without
// burning CPU on a sub-minute interval.
import { useEffect, useState } from 'react';

const CITIES = [
  { label: 'Los Angeles', tz: 'America/Los_Angeles' },
  { label: 'Texas',       tz: 'America/Chicago' },
  { label: 'New York',    tz: 'America/New_York' },
  { label: 'London',      tz: 'Europe/London' },
  { label: 'Manila',      tz: 'Asia/Manila' },
  { label: 'Sydney',      tz: 'Australia/Sydney' },
];

function fmt(now, tz) {
  const parts = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz,
  }).formatToParts(now);
  let hm = '';
  let suffix = '';
  for (const p of parts) {
    if (p.type === 'dayPeriod') suffix = p.value.toLowerCase();
    else hm += p.value;
  }
  hm = hm.trim();
  const h24 = parseInt(new Intl.DateTimeFormat('en-US', {
    hour: 'numeric', hour12: false, timeZone: tz,
  }).format(now), 10);
  const wd = new Intl.DateTimeFormat('en-US', {
    weekday: 'short', timeZone: tz,
  }).format(now);
  const weekend = wd === 'Sat' || wd === 'Sun';
  const workHours = h24 >= 8 && h24 < 20 && !weekend;
  return { hm, suffix, workHours };
}

export function WorldClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const ms = 60000 - (Date.now() % 60000);
    const t = setTimeout(() => setNow(new Date()), ms + 50);
    return () => clearTimeout(t);
  }, [now]);

  return (
    <>
      <div className="wclock-label">World</div>
      <div className="wclock">
        {CITIES.map(c => {
          const { hm, suffix, workHours } = fmt(now, c.tz);
          return (
            <div key={c.label} className={`wc-row${workHours ? '' : ' off-hours'}`}>
              <span className="city">{c.label}</span>
              <span className="time">
                {hm}
                <span style={{ marginLeft: 3, fontSize: 9, opacity: 0.7 }}>{suffix}</span>
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
}
